import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectPreferencesContactSubscriptionData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import {
  removeClientError,
  updateClientData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'

export type PhoneField = 'phone1' | 'phone2'

type Params = {
  field: PhoneField
  currentValue: string | null
  error: string | null
  onBlur: (value: string | null) => void
}

const usePhone = ({ field, currentValue, error, onBlur }: Params) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { isAdmin } = useSelector(selectAuthData)
  const preferences = useSelector(selectPreferencesContactSubscriptionData)
  const isForced = preferences[`${field}Forced`] === true

  const setForced = (value: boolean) =>
    // @ts-ignore
    dispatch(updateClientData({ data: { [`${field}Forced`]: value }, name: 'preferences' }))

  const forcePhone = () => {
    setForced(true)
    // @ts-ignore
    dispatch(removeClientError(field))
  }

  const handleBlur = (value: string | null) => {
    if ((value ?? '') !== (currentValue ?? '') && isForced) {
      setForced(false)
    }
    onBlur(value)
  }

  return {
    forceButtonHidden: !error || isAdmin !== true || isForced,
    caption: isForced ? t(`subscriptionForm:customer_module.${field}.forcedCaption`) : '',
    forcePhone,
    handleBlur,
  }
}

export default usePhone
